var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeDeactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_802_2119)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8649 0.278809C8.11487 0.278809 5.86487 2.52881 5.86487 5.27881C5.86487 7.87881 4.56487 10.2288 2.51487 11.9288C1.48987 12.7788 0.864868 13.9788 0.864868 15.2788H20.8649C20.8649 13.9788 20.2649 12.7788 19.2149 11.9288C17.1649 10.2288 15.8649 7.87881 15.8649 5.27881C15.8649 2.52881 13.6399 0.278809 10.8649 0.278809ZM8.36487 17.7788C8.36487 19.1538 9.48987 20.2788 10.8649 20.2788C12.2399 20.2788 13.3649 19.1538 13.3649 17.7788H8.36487Z",
    fill: "#8D8D8D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_802_2119"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.864868 0.278809)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeDeactive);
export default __webpack_public_path__ + "static/media/homeDeactive.ec7b3dda0902d29a3a124256fd68305e.svg";
export { ForwardRef as ReactComponent };